import { useState, useEffect } from 'react';

export type Environment = 'dev' | 'qa' | 'production' | 'production-india';

/**
 * Hook to manage and provide current environment context
 * Listen for environment changes and provides access control helpers
 */
export function useEnvironment() {
  const [environment, setEnvironment] = useState<Environment>(() => {
    // Initialize from localStorage or default to 'dev'
    return (localStorage.getItem('currentEnvironment') as Environment) || 'dev';
  });

  useEffect(() => {
    // Listens for custom event from EnvironmentSwitcher
    const handleEnvChange = (event: Event) => {
      const customEvent = event as CustomEvent<Environment>;
      if (customEvent.detail) {
        setEnvironment(customEvent.detail);
      }
    };

    window.addEventListener('environmentChanged', handleEnvChange);
    return () => {
      window.removeEventListener('environmentChanged', handleEnvChange);
    };
  }, []);

  /**
   * Access control helper for On-Prem module
   * Only 'dev' and 'production' are allowed to see On-Prem features
   */
  const isOnPremAllowed = environment === 'dev' || environment === 'production';

  return {
    environment,
    isOnPremAllowed,
  };
}
